const $ = require('jquery');
import {setElementsFromScope, insertTextAndClean} from "../../utilities/selectorHelpers";
import _ from "underscore";
import {merge} from "../../utilities/general";
import render from "../../utilities/render";
import run from "../../utilities/run";
import {isTruthy, keyDefaultFalseOption} from '../../utilities/general';
import {instantiateSelect2} from '../../utilities/select2able';
require("./lookupTable.less");

const elementsMap = {
  manageViewBtn: ".js-manage-view-modal-open",
  prevBtn: ".js-prev-page",
  nextBtn: ".js-next-page",
  pageDataInfo: ".page-data-info",
  searchInput: ".search-input",
  searchInputBtn: ".search-icon",
  searchInputDropdown: ".search-input-dropdown",
  perPageInput: ".total-per-page",
  loadingOverlay: ".table-loading-overlay",
  tableOrderHeaderTargets: "th:not(.sorting_disabled)",
  bulkSelectorHeader: ".lookup-bulk-select-thead",
  bulkSelectorsTbody: ".lookup-bulk-select-tbody",
  noDataErrorMsgWrap: ".data-table-error-msg-wrap",
  savedSearchLink: ".saved-search-link",
  savedSearchDropdown: "#savedSearch",
  newSavedViewBtn: ".new-saved-view-btn",
  savedSearchContainer: ".saved-search-section",
  filterBarContainer: ".applied-filter-section",
  appliedFilterPills: ".applied-filter-pills",
  pillFilter: ".pill-filter",
  deletePillFilterBtn: ".delete-pill-filter"
};

const manageViewModalElementsMap = {
  applyViewBtn: ".js-apply-view",
  parentInput: ".filter-modal-input",
  dateRangeInputs: ".func-date-range-input",
  toggleColumnInput: ".column-modal-input",
  dateRangeStart: ".func-date-range-input#startDate",
  dateRangeEnd: ".func-date-range-input#endDate",
  manageViewModalForm: ".manageViewModalForm",
  btnTabTrigger: ".btn-tab-trigger",
  topCloseBtn: ".top-close-btn",
  manageModalCancelBtn: ".js-manage-modal-cancel",
  deleteSavedViewBtn: ".js-delete-saved-view",
  manageViewNameInput: '.manage-view-name'
}

const modalHtml = require('../../sharedHtml/modal.html');
const defaultDesktopHtml = require('./html/defaultDesktopHtml.html');
const mobileWithTitleHtml = require('./html/mobileWithTitleTemplate.html');
const baseHtml = require('./html/baseTemplate.html');
const bulkSelectTemplateHtml = require('./html/bulkSelectTemplate.html');
const perPageSelectHtml = require('./html/perPageSelect.html');
const pageNavigationHtml = require('./html/pageNavigation.html');
const pageDataInfoHtml = require('./html/pageDataInfo.html');
const columnModalCheckboxHtml = require('./html/columnModalCheckbox.html');
const filterGroupCheckboxHtml = require('./html/filterGroupCheckbox.html');
const filterGroupRadioHtml = require('./html/filterGroupRadio.html');
const filterGroupDateRangeHtml = require('./html/filterGroupDateRange.html');
const filterModalBodyGroupHtml = require('./html/filterModalBodyGroup.html');
const childFiltersWrapHtml = require('./html/childFiltersWrap.html');
const btnSectionHtml = require('./html/btnSection.html');
const searchInputHtml = require('./html/searchInput.html');
const searchDropdownOptionHtml = require('./html/searchDropdownOption.html');
const noDataAlertHtml = require("./html/noDataAlert.html");
const savedSearchBarListWrapHtml = require('./html/modifiedLinkTemplates/linkListWrap.html');
const savedSearchBarLinkHtml = require('./html/modifiedLinkTemplates/linkTemplate.html');
const savedSearchBarOptionHtml = require('./html/modifiedLinkTemplates/optionTemplate.html');
const appliedFilterBarHtml = require("./html/appliedFilterBar.html");
const manageViewModalBodyHtml = require("./html/manageViewModalBody.html");
const filterPillTemplateHtml = require("./html/filterPillTemplate.html");

const buildFilterModalInputListConfig = {
  checkbox: filterGroupCheckboxHtml,
  radio: filterGroupRadioHtml,
  dateRange: filterGroupDateRangeHtml
}

export default function LookupTable(options={}) {
  //Create sorting type of noop so that sorting doesnt happen
  $.fn.dataTable.ext.order['noop'] = function( settings, col ){
    return this.api().column( col, {order:'index'} ).data().map(()=>(null));
  }

  const self = this;
  let tableWrapEl, tableEl, responsiveTable, noDataErrorMsg, manageViewModal;
  const els = {};
  const manageViewModalEls = {};
  // Currently set to md breakpoint
  let isMobile = window.innerWidth < 991;
  let firstRender = true;
  let pillFilter;
  let updateView = false;
  let date = new Date();
  let validator;
  let deletedView;
  const bulkSelectObj = {
    data: "select",
    title: "Select",
    render: renderSelect,
  }

  const bulkSelectModalColumn = {
    data: "select",
    title: "Bulk Select",
    active:true,
    canToggle:false
  }

  // Sets default options, overridden by user defined ones.
  const opts = merge(options, {
    // NOTE: Merge does not seem to work on direct 'key: "string"' pairs.
    dataTable: {
      dom: "t",
      paging: false,
      ordering: true,
      info: false,
      autoWidth: false
    }
  });

  if (_.isUndefined(opts.tableSearch)){
   opts.tableSearch = true
  }
  opts.newViewIndexOverride = opts.newViewIndexOverride ? opts.newViewIndexOverride:0

  let pageNumberTarget = currentPageNumber();

  const dataTableOpts = opts.dataTable;

  let validationOpts = {
    debug: true,
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  }

  addSavedStateBulkSelect();

  if(opts.bulkSelect === true){
    opts.dataTable.columns.unshift(bulkSelectObj);

    opts.dataTable.columnDefs.push({
      className: "select-for-bulk-upload",
      targets: [ 0 ],
      orderable: false,
      width: "50px"
    });
  }

  function renderSelect(data, type, row, meta){
    return render(
      bulkSelectTemplateHtml, {
        value: meta.row,
        placement: "tbody"
      }
    )
  }

  // Function to add a render function to each column if user-defined one doesn't exist
  opts.dataTable.columns = _(opts.dataTable.columns).map((columnConfig)=>{
    const render = columnConfig.render;
    columnConfig = _.extend(columnConfig, {
      render: smartRenderRow(render),
      //Set the default sorting to new sort type of noop to prevent data table sorting implementation
      orderDataType: "noop"
    });
    return columnConfig;
  });

  function defaultDesktopRender(data, type, row) {
    return data;
  }

  // Exposed Functions

  self.init = function(){
    buildHtml();
    setElements();
    bindElements();
    setPaginationData(opts.paginationData);
    handleWindowResize();
    toggleFilterModalChildInput();
    handleDisabledBtns();
  }

  self.generateData = function() {
    return generateData();
  }

  self.setNewData = function(data) {
    setNewData(data);
  }

  self.setPaginationData = function(data) {
    setPaginationData(data);
  }

  self.getBulkSelectedData = function() {
    return getBulkSelectedData();
  }

  self.onBulkSelectChange = function() {
    onBulkSelectChange();
  }

  self.showLoadingOverlay = function() {
    showLoadingOverlay();
  }

  self.hideLoadingOverlay = function() {
    hideLoadingOverlay();
  }

  self.setNewSavedViewData = function(newSearchData, dataTarget) {
    setNewSavedViewData(newSearchData, dataTarget)
  }

  self.removeSavedView = function(target) {
    removeSavedView(target);
  }

  self.uncheckAllSelected = function() {
    uncheckAllSelected();
  }

  function bindElements(){
    els.nextBtn.on('click', handlePageNavNext);
    els.prevBtn.on('click', handlePageNavPrev);
    tableWrapEl.on('click', elementsMap.manageViewBtn, onManageViewBtnClick);
    els.searchInput.on('keyup', onSearchEnter);
    els.searchInputBtn.on('click', resetPageThenFetch);
    els.perPageInput.on('change', resetPageThenFetch);
    els.bulkSelectorsTbody.on('change', onBulkSelectChange);
    manageViewModal.on('click', manageViewModalElementsMap.applyViewBtn, onManageViewApplyClick);
    // manageViewModal.on('change', manageViewModalElementsMap.toggleColumnInput, toggleVisibleColumn);
    manageViewModal.on('change', manageViewModalElementsMap.parentInput, toggleFilterModalChildInput);
    tableWrapEl.on('click', elementsMap.savedSearchLink, onSavedSearchClick)
    tableEl.on('click', elementsMap.tableOrderHeaderTargets, onOrderTableHeaderClick);
    tableEl.on('change', elementsMap.bulkSelectorHeader, handleAllBulkSelectsChange);
    tableEl.on('change', elementsMap.bulkSelectorsTbody, onBulkSelectChange);
    tableWrapEl.on('change', elementsMap.savedSearchDropdown, onSavedSearchClick);
    manageViewModal.on('click', manageViewModalElementsMap.topCloseBtn,  onManageViewCancelClick);
    manageViewModal.on('click', manageViewModalElementsMap.manageModalCancelBtn,  onManageViewCancelClick);
    tableWrapEl.on('click', elementsMap.newSavedViewBtn, onNewSavedSearchClick);
    manageViewModal.on('click', manageViewModalElementsMap.deleteSavedViewBtn,  onDeleteSavedViewClick);
    tableWrapEl.on('click', elementsMap.deletePillFilterBtn, onDeletePillFilterClick);
    // Look at the button tab trigger function to make a component later...
    manageViewModal.on('click', manageViewModalElementsMap.btnTabTrigger, toggleShownTab);
    bindManageModalBody();
  }

  function buildHtml() {
    let initialModalBody;
    let initialModalButtons;
    let hasTableSearch = true;
    if (opts.tableSearch === false) {
      hasTableSearch = false;
    }
    if (opts.savedViews && opts.savedViews.length >= 1) {
      pillFilter = true;
      let targetView = _(opts.savedViews).findWhere({active: true});
      initialModalBody = buildManageModalBody(targetView.filters, targetView.columns, targetView.title, targetView.target);
      initialModalButtons = `
        <a href="#" class="base-btn v2-btn js-manage-modal-cancel">Cancel</a>
        <a href="#" class="base-btn v2-btn js-delete-saved-view">Delete View</a>
        <a href="#" class="base-btn purple-btn js-apply-view">Save View</a>
      `
    } else {
      initialModalBody = buildManageModalBody(opts.tableFilters.data, opts.tableColumnModal.data);
      initialModalButtons = `
        <a href="#" class="base-btn v2-btn js-manage-modal-cancel">Cancel</a>
        <a href="#" class="base-btn purple-btn js-apply-view">Save Filters</a>
       `
    }

    let searchPlaceholder = "Enter your search here...";
    let searchInput = "";
    if (opts.tableSearchInput) {
      searchPlaceholder = opts.tableSearchInput.placeholder;
      searchInput = opts.tableSearchInput.value;
    }
    tableWrapEl = $(render(
      baseHtml, {
        tableSearch: hasTableSearch,
        searchInput: render(
          searchInputHtml, {
            dropDownOptions: setSearchDropdownOptions(),
            searchInputPlaceholder: searchPlaceholder,
            searchInputValue: searchInput
          },
        ),
        savedSearchBar: renderSavedSearchSection(opts.savedViews),
        appliedFilterBar: renderAppliedFilterBar(),
        btnSectionHtml,
        perPageSelectHtml,
        pageDataInfo: render(
          pageDataInfoHtml, {
            pageData: buildPageInfoText()
          },
        ),
        pageNavigation: render(
          pageNavigationHtml, {
             nextPage: nextPageNumber(),
             prevPage: prevPageNumber()
          },
        )
      }
    ));
    manageViewModal = $(render(
      modalHtml, {
        title: "Manage View",
        leftAlignTitle: true,
        topCloseBtn: true,
        autoHideTop: false,
        staticBackdrop: true,
        body: initialModalBody,
        footerBtns: initialModalButtons,
      }
    ));
    $('body').append(manageViewModal);
    $(opts.target).html(tableWrapEl);
    tableWrapEl.find(elementsMap.appliedFilterPills).html(renderAppliedFilterPills());
    tableEl = tableWrapEl.find('.data-table-component');
    noDataErrorMsg = tableWrapEl.find(elementsMap.noDataErrorMsgWrap);
    responsiveTable = tableEl.dataTable({...dataTableOpts});
    responsiveTable.find(".select-for-bulk-upload").html(renderBulkSelectHeader());
    noDataErrorMsg.html(getNoDataAlert());
    // If this if block doesn't run, dropdown will default to first value
    // This needs to run after HTML of dropdown and input is rendered
    if (opts.tableSearch && opts.tableSearchDropdown.selected) {
      $(elementsMap.searchInputDropdown).val(opts.tableSearchDropdown.selected).trigger("change.select2");
    }
  }

  function renderBulkSelectHeader(){
    return render(bulkSelectTemplateHtml,
      {
        value: "header",
        rowObj: "",
        placement: "thead"
      }
    )
  }

  function getNoDataAlert(){
    return render(noDataAlertHtml);
  }

  function checkForHasData(){
    // NOTE: this looks for "totalElements" in paginationData in the object
    if(!hasTableData()) {
      responsiveTable.addClass("q-display-none");
      noDataErrorMsg.removeClass("q-display-none");
    } else {
      responsiveTable.removeClass("q-display-none");
      noDataErrorMsg.addClass("q-display-none");
    }
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, tableWrapEl);
    setElementsFromScope(manageViewModalEls, manageViewModalElementsMap, manageViewModal);
  }

  function smartRenderRow(func) {
    return function(data, type, row, meta) {
      if(isMobile){
        return handleMobileRender(data, type, row);
      }
      else {
        if (func) {
          return func(data, type, row, meta);
        } else {
          return handleDesktopRender(data, type, row, meta);
        }
      }
    }
  }

  $(window).on('resize', _.debounce(handleWindowResize));

  function handleWindowResize() {
    if (window.innerWidth < 991 && (!isMobile || firstRender)) {
      isMobile = true;
      _.each(dataTableOpts.columns, function(obj, i) {
        hideColumnsForMobile(obj, i);
      });
      responsiveTable.api().rows().invalidate();
      responsiveTable.api().draw(false);
    } else if(window.innerWidth >= 991 && (isMobile || firstRender)){
      isMobile = false;
      setVisibleColumns();
      responsiveTable.api().rows().invalidate();
      responsiveTable.api().draw(false);
    }
    firstRender = false;
  }

  function hideColumnsForMobile(obj, i) {
    if (i === 0) {
      responsiveTable.api().columns(i).visible(true);
    } else {
      responsiveTable.api().columns(i).visible(false);
    }
  }

  function handleMobileRender(data, type, row) {
    let newData = _(opts.mobileColumns).map((config)=>{
      if (config.render) {
        // Remap the given row's data based on current mobile columns
        // data key. Because of this, we are making the assumption that
        // mobile columns will never exceed the number of desktop columns.

        // Make sure 'type' is mapped correctly, based on row
        return config.render(row[config.data], type, row);
      } else {
        return handleDefaultMobileColumnRender(config, data, type, row);
      }
    });
    if(els.bulkSelectorHeader && opts.bulkSelect === true){
      els.bulkSelectorHeader.prop("checked", false);
    }
    return newData.join('');
  }

  function handleDefaultMobileColumnRender(config, data, type, row) {
    let link;
    const linkConfig = row[config.linkKey];
    if( linkConfig && config.data === linkConfig.data){
      link = row[config.linkKey].link
    }
    let item = {
      content: row[config.data],
      label: config.title,
      link: link
    }
    return buildMobileData(item);
  }

  function handleDesktopRender(data, type, row, meta) {
    let link;
    let columnTarget = opts.dataTable.columns[meta.col].data;
    let linkObj = row[opts.dataTable.columns[meta.col].linkKey];
    if (linkObj !== undefined && columnTarget === linkObj.data) {
      link = linkObj.link
    }
    let item = {
      content: data,
      link: link
    }
    return buildDesktopData(item);
  }

  function buildDesktopData(item) {
    const newCell = render(
      defaultDesktopHtml,
      item
    )
    return newCell;
  }

  function buildMobileData(item) {
    const newCell = render(
      mobileWithTitleHtml,
      item
    )
    return newCell;
  }

  function onFetch() {
    options.onFetch && options.onFetch();
    responsiveTable.api().draw(false);
    if (opts.savedViews && opts.savedViews.length >= 1) {
      pillFilter = true;
      updateView = false;
    }
    deletedView = '';

  }

  function resetPageThenFetch() {
    pageNumberTarget = 0;
    onFetch();
  }

  function handlePageNavNext(e) {
    e.preventDefault();
    let btnEl = $(this);
    if (!btnEl.hasClass('disabled')) {
      pageNumberTarget = nextPageNumber();
      onFetch();
    }
  }

  function handlePageNavPrev(e) {
    e.preventDefault();
    let btnEl = $(this);
    if (!btnEl.hasClass('disabled')) {
      pageNumberTarget = prevPageNumber();
      onFetch();
    }
  }

  function generateData() {
    let targetView;
    let savedViewTarget;
    let savedViewTitle;
    let targetColumns;
    if (opts.savedViews && opts.savedViews.length >= 1) {
      targetView = _(opts.savedViews).findWhere({active: true});
      targetColumns = targetView.columns;
      savedViewTarget = targetView.target;
      savedViewTitle = targetView.title;
    } else {
      targetColumns = opts.tableColumnModal.data;
    }
    if(opts.bulkSelect === true && targetColumns[0].title === "Bulk Select") {
      targetColumns.shift();
    };
    // appliedFilterPills: ".applied-filter-pills",
    // pillFilter: ".pill-filter",
    //
    let filterDataArray;
    if (!pillFilter) {
      filterDataArray = getFilterModalData(manageViewModal, '.manage-filter-list input:checked, .manage-filter-list input[type="text"]');
    } else {
      filterDataArray = getFilterModalData($(elementsMap.appliedFilterPills), elementsMap.pillFilter);
    }
    let searchData = getSearchData();
    let searchCriteria = [
      searchData,
      ...filterDataArray
    ]
    searchCriteria = _(searchCriteria).filter((filterData) => {
      return filterData && _.has(filterData, "key") && _.has(filterData, "operation") && _.has(filterData, "value");
    });
    let tableData = {
      searchCriteria,
      size: getItemsPerPageData(),
      number: pageNumberTarget,
      totalElements: totalResults(),
      ...generateOrderData(),
      targetColumns: [...targetColumns],
      savedViewTarget,
      savedViewTitle,
      deletedView,
      updateView
    };
    addSavedStateBulkSelect();
    return tableData;
  }

  function generateOrderData() {
    let orderData = {};
    // IF USING DATATABLES SORTING
    let order = responsiveTable.api().order();
    let sortColumnIdx = order[0][0];
    orderData.sortField = opts.dataTable.columns[sortColumnIdx].data;
    orderData.sortType = order[0][1];
    orderData.orderBy = orderData.sortField;
    orderData.orderByType = orderData.sortType;

    return orderData;
  }

  function setNewData(data) {
    if(opts.bulkSelect === true){
      els.bulkSelectorHeader.prop("checked", false);
    }
    responsiveTable.fnClearTable();
    if (data.length > 0) {
      responsiveTable.fnAddData(data);
    }
  }

  function getFilterModalData(parent, target) {
    // filterGroups = {
    //   status: {
    //     key: 'status'
    //     operation: 'equal',
    //     value: ['inStock','lowStock']
    //   },
    // }
    let filterGroups = {}
    _(parent.find(target)).each((item) => {
      const key = $(item).attr('name') || $(item).data('name');
      const operation = $(item).data('operator');
      const value = $(item).val() || $(item).data('value');
      filterGroups[key] = filterGroups[key] || { value:[] };
      filterGroups[key].value.push(value);
      filterGroups[key].operation = operation;
      filterGroups[key].key = key;
    });
    return _(filterGroups).values();
  }

  function getSearchData() {
    let filterGroup = {};
    // If no search term is used, they want this to be blank.
    if (!els.searchInput.val()) {
      return;
    }
    // Value needs to be returned as an array, will investigate solution based on UX reqs in the future (thinking we pull previous search terms into array as well).
    filterGroup = {
      key: els.searchInputDropdown.val(),
      value: [$.trim(els.searchInput.val())], 
      operation: 'like'
    }
    return filterGroup;
  }

  function getSearchInputData() {
    let searchInput = tableWrapEl.find('.search-input');
    let searchObj = {
      value: searchInput.val() || "",
    }
    return searchObj;
  }

  function getBulkSelectedData() {
    let bulkSelected = [];
    $.each(tableEl.find(elementsMap.bulkSelectorsTbody), function(i, v){
      const trInput = $(v);
      const targetRow = trInput.closest('tr');
      if(trInput.is(":checked")){
        let passedData = {
          checkboxIndex: i,
          rowIndex: responsiveTable.api().row(targetRow).index(),
          data: responsiveTable.api().row(targetRow).data()
        }
        bulkSelected.push(passedData);
      };
    });

    return bulkSelected;
  }

  function setSearchDropdownOptions() {
    let hasTableSearch = true;
    if (opts.tableSearch === false) {
      hasTableSearch = false;
    }
    if (hasTableSearch) {
      let options = _(opts.tableSearchDropdown.columns).map((item) => {
        let option = render(
          searchDropdownOptionHtml, {
            name: item.name,
            value: item.value,
            title: item.title
          }
        );
        return option;
      });
      return options;
    }
  }

  function getItemsPerPageData() {
    return parseInt(els.perPageInput.val());
  }

  function setPaginationData(data) {
    setTableData(data);
    renderPagination();
    checkForHasData();
  }

  function openManageViewModal() {
    manageViewModal.modal("show");
  }

  function closeManageViewModal() {
    manageViewModal.modal("hide");
  }

  function onManageViewBtnClick(e) {
    e.preventDefault();
    $(manageViewModalElementsMap.manageViewModalForm).parents('.modal-content').find(manageViewModalElementsMap.deleteSavedViewBtn).show();
    openManageViewModal();
  }

  function onManageViewCancelClick(e) {
    e.preventDefault();
    addSavedStateBulkSelect();
    let updateModalBody;
    let savedSearchTargetView = _(opts.savedViews).findWhere({active: true});
    if (opts.savedViews && opts.savedViews.length >= 1) {
      let targetView = _(opts.savedViews).findWhere({active: true});
      updateModalBody = buildManageModalBody(targetView.filters, targetView.columns, targetView.title, targetView.target);
    } else {
      updateModalBody = buildManageModalBody(opts.tableFilters.data, opts.tableColumnModal.data)
    }
    closeManageViewModal();
    // Timeout to match the animation timing.
    setTimeout(() => {
      $(manageViewModalElementsMap.manageViewModalForm).closest('div').html(updateModalBody);
      bindManageModalBody();
    }, 300);
  }

  function onManageViewApplyClick(e) {
    e.preventDefault();
    addSavedStateBulkSelect();
    pillFilter = false;
    let isValid = validateChildren();
    let formTarget = $(manageViewModalElementsMap.manageViewModalForm).data('target-view');
    let inputVal = $(manageViewModalElementsMap.manageViewModalForm).find(manageViewModalElementsMap.manageViewNameInput).val();
    updateView = true;
    if (isValid) {
      let currentActiveView = _(opts.savedViews).findWhere({active: true});
      if (formTarget === 'newSavedView') {
        currentActiveView.active = false;
        let newSavedView = {
          title: inputVal,
          target: "newSavedView",
          active:true,
          canRemove: true,
          canEdit: true,
          // Expecting these to be returned in the setting of new saved data...
          filters: [],
          // Expecting these to be returned in the setting of new saved data...
          columns: []
        }
        opts.savedViews.push(newSavedView);
        els.filterBarContainer.html(renderAppliedFilterBar());
      } else if (currentActiveView) {
        currentActiveView.title = inputVal;
      }
      tableWrapEl.find(elementsMap.appliedFilterPills).html(renderAppliedFilterPills());
      closeManageViewModal();
      setNewColumnList();
      setVisibleColumns();
      resetPageThenFetch();
    }
  }

  function setVisibleColumns() {
    // probably a better way to do this, but it works for now.
    addSavedStateBulkSelect();
    if (!isMobile) {
      let columnSource;
      if (opts.savedViews && opts.savedViews.length >= 1) {
        columnSource = _(opts.savedViews).findWhere({active: true}).columns;
      } else {
        columnSource = opts.tableColumnModal.data;
      }
      _(manageViewModal.find('.manage-column-list input')).each((input, i) => {
        let newIndex = i;
        if(opts.bulkSelect === true){
          newIndex = i + 1;
        };
        let status = false;
        let checkboxEl = $(input);
        let columnTarget = columnSource[checkboxEl.data('column-index')];
        if (checkboxEl.prop('checked')) {
          status = true;
        }
        if (!checkboxEl.attr('disabled')) {
          columnTarget.active = status;
        }
        responsiveTable.api().column(newIndex).visible(status);
      });
    }
  }

  // function toggleVisibleColumn() {
    // addSavedStateBulkSelect();
    // let checkboxEl = $(this);
    // let columnSource;
    // if (opts.savedViews && opts.savedViews.length >= 1) {
    //   columnSource = _(opts.savedViews).findWhere({active: true}).columns;
    // } else {
    //   columnSource = opts.tableColumnModal.data;
    // }
    // let columnTarget = columnSource[checkboxEl.data('column-index')];
    // let status = false;
    // if ($(this).prop('checked')) {
    //   status = true;
    // }
    // if (!checkboxEl.attr('disabled')) {
    //   columnTarget.active = status;
    // }
  // }

  function onSearchEnter(e) {
    e.preventDefault();
    let keycode = (e.keyCode ? e.keyCode : e.which);
    if (keycode == '13') {
      $(this).blur();
      resetPageThenFetch();
    }
  }

  function showLoadingOverlay() {
    els.loadingOverlay.show();
  }

  function hideLoadingOverlay() {
    els.loadingOverlay.hide();
  }

  function onBulkSelectChange() {
    options.onBulkSelectChange && options.onBulkSelectChange();
  }

  // START: Saved Search

  function renderSavedSearchSection(data) {
    if (data && data.length >= 1) {
      let addSavedViews = true;
      if (opts.newSavedViews === false) {
        addSavedViews = false;
      }
      let listObj = {
        linkList: '',
        optionList: ''
      };
      let activeSearch = true;
      let filterList = _(data).map((view)=>{
        let linkRender = renderSavedSearchItem(view, savedSearchBarLinkHtml);
        let optionRender = renderSavedSearchItem(view, savedSearchBarOptionHtml);
        listObj.linkList = listObj.linkList + linkRender;
        listObj.optionList = listObj.optionList + optionRender;
        if (view.active === true) {
          activeSearch = false;
        }
      });
      let returnRender = render(
        savedSearchBarListWrapHtml, {
          ...listObj,
          dropdownId: 'savedSearch',
          dropdownName: 'savedSearch',
          dropdownPlaceholder: '',
          dropdownMinResultsForSearch: '5',
          newSavedViews: addSavedViews
        }
      );
      return returnRender;
    }
  }

  function renderAppliedFilterPills() {
    let pillList = [];
    let startDate
    _(manageViewModal.find('.manage-filter-list input:checked, .manage-filter-list input[type="text"]')).each((item) => {
      let $item = $(item);
      let itemLabel;
      let visible = true;
      if ($item.attr('id') === 'endDate' || $(item).attr('id') === 'startDate') {
        visible = false;
      } else {
        if ($item.attr('type') === 'radio') {
          itemLabel = $.trim($item.siblings('.q-cr-label').text());
        } else {
          itemLabel = $.trim($item.siblings('.cb-label-inner').text());
        }
      }
      let pillRender = render(
        filterPillTemplateHtml, {
          operator: $item.data('operator'),
          name: $item.attr('name'),
          value: $item.val(),
          title: itemLabel,
          visible
        }
      );
      pillList.push(pillRender);
    });
    return pillList;
  }

  function renderSavedSearchItem(view, template) {
    let uniqueClass = elementsMap.savedSearchLink.split('.').join("");
    let newRender = render(
      template, {
        targetKey: view.target,
        text: view.title,
        linkHref: "#",
        uniqueClass,
        active: view.active
      }
    );
    return newRender;
  }

  function initAndBindSavedSearchDropdown() {
    instantiateSelect2($(elementsMap.savedSearchDropdown));
    let currentView = _(opts.savedViews).findWhere({active: true});
    $(elementsMap.savedSearchDropdown).val(currentView.target).trigger('change.select2');
  }

  function onSavedSearchClick(e) {
    // How to get only the clicked target, for future reference if needed
    // let savedSearchTargetView = _(opts.savedViews).findWhere({target: savedSearchTarget});
    e.preventDefault();
    pillFilter = false;
    // Get target
    let clickedBtnEl = $(e.target);
    // Get data from target, or value from select
    let savedSearchTarget = clickedBtnEl.data('link-info') || clickedBtnEl.val();
    // Set Clone Array Data...
    // opts.savedViews = JSON.parse(JSON.stringify(opts.savedViews));
    // If clicked item is active, don't run
    if (clickedBtnEl.hasClass('active')) {
      return;
    }
    // Loop over list, setting the new active state
    let savedViewList = _(opts.savedViews).map((view)=>{
      if (view.target == savedSearchTarget) {
        view.active = true;
        els.filterBarContainer.html(renderAppliedFilterBar());
        addSavedStateBulkSelect();
        $(manageViewModalElementsMap.manageViewModalForm).closest('div').html(buildManageModalBody(view.filters, view.columns, view.title, view.target));
        setVisibleColumns();
        $(elementsMap.savedSearchLink).removeClass('active');
        $(elementsMap.savedSearchLink + '[data-link-info="' + savedSearchTarget + '"]').addClass('active');
      } else {
        view.active = false;
      }
    });
    // render pills
    tableWrapEl.find(elementsMap.appliedFilterPills).html(renderAppliedFilterPills());
    bindManageModalBody();
    // Fetch new data.
    initAndBindSavedSearchDropdown();
    resetPageThenFetch();
  }

  function onDeleteSavedViewClick(e) {
    e.preventDefault();
    pillFilter = false;
    deletedView = _(opts.savedViews).findWhere({active: true});
    opts.savedViews[0].active = true;
    closeManageViewModal();
    // Timeout to match the animation timing.
    setTimeout(() => {
      els.filterBarContainer.html(renderAppliedFilterBar());
      // els.savedSearchContainer.html(renderSavedSearchSection(opts.savedViews));
      $(elementsMap.savedSearchLink).removeClass('active');
      $(elementsMap.savedSearchLink + '[data-link-info="' + opts.savedViews[0].target + '"]').addClass('active');
      addSavedStateBulkSelect();
      $(manageViewModalElementsMap.manageViewModalForm).closest('div').html(buildManageModalBody(opts.savedViews[opts.newViewIndexOverride].filters, opts.savedViews[opts.newViewIndexOverride].columns, opts.savedViews[opts.newViewIndexOverride].title, opts.savedViews[opts.newViewIndexOverride].target));
      tableWrapEl.find(elementsMap.appliedFilterPills).html(renderAppliedFilterPills());
      setVisibleColumns();
      bindManageModalBody();
      resetPageThenFetch();
    }, 300);
  }

  function removeSavedView(deleteTarget) {
    opts.savedViews = _.without(opts.savedViews, _.findWhere(opts.savedViews, {
      target: deleteTarget
    }));
    els.savedSearchContainer.html(renderSavedSearchSection(opts.savedViews));
    initAndBindSavedSearchDropdown();
  }

  function onDeletePillFilterClick(e) {
    e.preventDefault();
    let clickedPillEl = $(e.target)
    let clickedPillParentEl = $(e.target).closest(elementsMap.pillFilter);
    if (clickedPillParentEl.data('value') === 'customRange') {
      clickedPillParentEl.siblings('[data-name="startDate"], [data-name="endDate"]').removeAttr('data-value');
    }
    clickedPillParentEl.remove();
    resetPageThenFetch();
  }

  function setNewSavedViewData(newSearchData, dataTarget) {
    if (opts.savedViews && opts.savedViews.length >= 1) {
      let targetView = _(opts.savedViews).findWhere({target: dataTarget});
      if (targetView) {
        targetView.title = newSearchData.title;
        targetView.target = newSearchData.target;
        targetView.active = newSearchData.active;
        targetView.canRemove = newSearchData.canRemove;
        targetView.canEdit = newSearchData.canEdit;
        targetView.filters = newSearchData.filters;
        targetView.columns = newSearchData.columns;
        // targetView = {...targetView, ...newSearchData};
        // console.log(opts.savedViews);
      }
      let activeView = _(opts.savedViews).findWhere({active: true});
      els.savedSearchContainer.html(renderSavedSearchSection(opts.savedViews));
      initAndBindSavedSearchDropdown();
      addSavedStateBulkSelect();
      $(manageViewModalElementsMap.manageViewModalForm).closest('div').html(buildManageModalBody(activeView.filters, activeView.columns, activeView.title, activeView.target));
      setVisibleColumns();
      bindManageModalBody();
    }
    // else if (opts.savedViews && opts.savedViews.length < 1) {
    //   opts.savedViews.push(newSearchData);
    //   els.savedSearchContainer.html(renderSavedSearchSection(opts.savedViews));
    //   let savedViewList = _(opts.savedViews).map((view)=>{
    //     els.filterBarContainer.html(renderAppliedFilterBar());
    //     addSavedStateBulkSelect();
    //     $(manageViewModalElementsMap.manageViewModalForm).closest('div').html(buildManageModalBody(view.filters, view.columns, view.title, view.target));
    //     setVisibleColumns();
    //     bindManageModalBody();
    //   });
    // }
  }

  function setNewColumnList() {
    if (opts.savedViews && opts.savedViews.length >= 1) {
      let savedSearchTargetView = _(opts.savedViews).findWhere({active: true});
      savedSearchTargetView.columns = [];
      _(manageViewModal.find('.manage-column-list input[type="checkbox"]')).each((column) => {
        let columnEl = $(column);
        let toggleable = true;
        if (columnEl.attr('disabled')) {
          toggleable = false;
        }
        let newColumnObj =  {
          data: columnEl.val(),
          title: $.trim(columnEl.siblings('span').text()),
          active:columnEl.prop('checked'),
          canToggle:toggleable,
        }
        savedSearchTargetView.columns.push(newColumnObj);
      });
      addSavedStateBulkSelect();
    }
  }

  function addSavedStateBulkSelect() {
    if (opts.savedViews && opts.savedViews.length >= 1) {
      let savedSearchTargetView = _(opts.savedViews).findWhere({active: true});
      if(opts.bulkSelect === true && savedSearchTargetView.columns[0].title !== "Bulk Select"){
        savedSearchTargetView.columns.unshift(bulkSelectModalColumn);
      }
    } else {
      if(opts.bulkSelect === true && opts.tableColumnModal.data[0].title !== "Bulk Select") {
        opts.tableColumnModal.data.unshift(bulkSelectModalColumn);
      }
    }
  }

  function onNewSavedSearchClick(e) {
    e.preventDefault();
    $(manageViewModalElementsMap.manageViewModalForm).closest('div').html(buildManageModalBody(opts.savedViews[opts.newViewIndexOverride].filters, opts.savedViews[opts.newViewIndexOverride].columns, '', 'newSavedView'));
    $(manageViewModalElementsMap.manageViewModalForm).parents('.modal-content').find(manageViewModalElementsMap.deleteSavedViewBtn).hide();
    bindManageModalBody();
    openManageViewModal();
  }

  function renderAppliedFilterBar() {
    if (opts.savedViews && opts.savedViews.length >= 1) {
      let savedSearchTargetView = _(opts.savedViews).findWhere({active: true});
      let appliedFilterRender = render(
        appliedFilterBarHtml, {
          target:savedSearchTargetView.target,
          canEdit: savedSearchTargetView.canEdit,
          canRemove: savedSearchTargetView.canRemove,
          title: savedSearchTargetView.title,
        }
      );
      return appliedFilterRender;
    }
  }


  // END: Saved Search

  // Manage View Modal

  function buildManageModalBody(filterData, columnData, inputValue, targetView) {
    let modalBody = render(
      manageViewModalBodyHtml, {
        inputValue,
        targetView,
        filterList: buildFilterModalGroupBody(filterModalBodyGroupHtml, filterData),
        columnList: buildColumnModalInputList(columnModalCheckboxHtml, columnData),
      }
    );
    return modalBody;
  }

  function bindManageModalBody() {
    // have to re-bind all of these things since I'm re-rendering
    $(manageViewModalElementsMap.dateRangeInputs).datepicker({
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    });
    manageViewModal.find(manageViewModalElementsMap.dateRangeEnd).on('click', (e)=> {
      let initDate = $(manageViewModalElementsMap.dateRangeStart).datepicker('getDate');
      if (initDate) {
        initDate = moment(initDate).add(1, 'days').toDate();
        manageViewModal.find(manageViewModalElementsMap.dateRangeEnd).datepicker('setStartDate', initDate);
      } else if (initDate === null) {
        manageViewModal.find(manageViewModalElementsMap.dateRangeEnd).datepicker('setStartDate', null);
      }
    });
    manageViewModal.find(manageViewModalElementsMap.dateRangeStart).on('click', (e)=> {
      let initDate = $(manageViewModalElementsMap.dateRangeEnd).datepicker('getDate');
      if (initDate) {
        initDate = moment(initDate).subtract(1, 'days').toDate();
        manageViewModal.find(manageViewModalElementsMap.dateRangeStart).datepicker('setEndDate', initDate);
      } else if (initDate === null) {
        manageViewModal.find(manageViewModalElementsMap.dateRangeStart).datepicker('setEndDate', null);
      }
    });
    validator = manageViewModal.find(manageViewModalElementsMap.manageViewModalForm).validate(validationOpts);
    validator.settings.ignore = ":disabled,:hidden";
    $(manageViewModalElementsMap.manageViewNameInput).rules("add", {
      required: true,
      maxlength: 30,
      messages: {
        required: "This field is required.",
        maxlength: "Characters can't exceed 30."
      }
    });
  }

  // Column List

  function buildColumnModalInputList(template, list) {
    let columnInputList = _(list).map((column, index)=>{
      if(opts.bulkSelect === true && index === 0){
        return
      }
      return render(
        template, {
          title: column.title,
          name: column.data,
          value: column.data,
          active: keyDefaultFalseOption(column, "active"),
          columnIndex: index,
          canToggle: keyDefaultFalseOption(column, "canToggle"),
        }
      );
    });
    return columnInputList.join('');
  }


  // Filter List

  function buildFilterModalGroupBody(template, list) {
    let filters = _(list).map((item, index)=>{
      if (!item.filterGroupInputs) {
        item.filterGroupInputs = [{}];
      }
      let filterList = buildFilterModalInputList(item, item.filterGroupInputs, item.filterGroupType);
      return render(
        template, {
          title: item.filterGroup,
          filterList: filterList,
          index
        }
      );
    });
    return filters.join('');
  }

  function buildFilterModalInputList(item, list, type) {
    let filterList = _(list).map((input)=>{
      // Example:
      // {
      //   checkbox: filterGroupCheckboxHtml,
      // }
      const filterTemplate = buildFilterModalInputListConfig[type];
      let filterChildren = "";
      if (input.childFilters) {
        filterChildren = buildFilterModalGroupBody(childFiltersWrapHtml, input.childFilters);
      }
      return render(
        filterTemplate, {
          title: input.filterTitle,
          name: input.filterName || item.filterGroupName,
          dateRangeNameStart:item.dateRangeNameStart,
          dateRangeNameEnd:item.dateRangeNameEnd,
          dateRangeStartVal: item.dateRangeStartVal || "",
          dateRangeEndVal: item.dateRangeEndVal || "",
          value: input.filterValue,
          active: input.active,
          operator: input.filterOperator,
          childFiltersHtml: filterChildren
        }
      );
    });
    return filterList.join('');
  }

  function toggleFilterModalChildInput(e) {
    let $self = $(this);
    if ($self.attr('type') === 'radio') {
      toggleFilterModalChildRadios($self);
    };
    let $target = $self.closest('.divider-group').find('.child-filters-entry');
    validator.resetForm();
    // USE BETTER SHOW/HIDE, LOW PRIORITY
    $target.show();
  }

  function toggleFilterModalChildRadios(radioEl) {
    let $radios = radioEl.closest('.input-list-section').find('input[type="radio"]');
    $radios.each(function() {
      let $curRadio = $(this);
      let $target = $curRadio.closest('.divider-group').find('.child-filters-entry');
      // Reset datepicker options.
      manageViewModalEls.dateRangeInputs.datepicker("setStartDate", false);
      manageViewModalEls.dateRangeInputs.datepicker("setEndDate", false);
      // USE BETTER SHOW/HIDE, LOW PRIORITY
      $target.find('input[type="text"]').val("");
      $target.hide();
    });
  }

  function uncheckAllSelected() {
    $(elementsMap.bulkSelectorHeader + ":checked").prop('checked', false);
    $(elementsMap.bulkSelectorsTbody + ":checked").each(function() {
      $(this).prop('checked', false);
    });
  }


  // Validation
  function validateChildren(){
    let isValid = false;
    if ($(manageViewModalElementsMap.manageViewModalForm).valid()) {
      isValid = true;
    }
    return isValid;
  }


  // PAGINATION HELPER FUNCTIONS, TAKEN FROM PAGINATION COMPONENT:

  function renderPagination(){
    insertTextAndClean(els.pageDataInfo, buildPageInfoText());
    handleDisabledBtns();
    els.perPageInput.val(perPageSize()).trigger('change.select2');
  };

  function setTableData(data){
    opts.paginationData = merge(opts.paginationData, data, {clone: true});
    renderPagination();
  }

  function handleDisabledBtns(){
    handleDisabledNextBtn();
    handleDisabledPrevBtn();
  }

  function handleDisabledNextBtn(){
    if(isBeforeLastPage()){
      els.nextBtn.removeClass('disabled');
      els.nextBtn.data('next-page', nextPageNumber());
    }
    else{
      els.nextBtn.addClass('disabled');
      els.nextBtn.data('next-page', null);
    }
  }

  function handleDisabledPrevBtn(){
    if(!isFirstPage()){
      els.prevBtn.removeClass('disabled');
      els.prevBtn.parent().data('previous-page', prevPageNumber());
    }
    else{
      els.prevBtn.addClass('disabled');
      els.prevBtn.parent().data('previous-page', null);
    }
  }

  function onOrderTableHeaderClick(e) {
    e.preventDefault();
    onFetch();
  }

  function handleAllBulkSelectsChange(e){
    e.preventDefault();
    const headerIsSelected = $(e.target).is(":checked");
    setAllBulkSelects(headerIsSelected);
    onBulkSelectChange();
  }

  function setAllBulkSelects(headerIsSelected){
    responsiveTable.find(elementsMap.bulkSelectorsTbody).prop("checked", headerIsSelected);
  }

  // function setBulkSelectHeader(isSelected){
  //   responsiveTable.find(elementsMap.bulkSelectorHeader).prop("checked", isSelected);
  //   setAllBulkSelects(isSelected);
  // }

  function buildPageInfoText(){
    let paginationText = "Showing";
    if(hasTableData()){
      return `${paginationText} ${exclusiveResultsShownTotal()} - ${computedInclusiveResultsShownTotal()} of ${totalResults()}`
    }
    else{
      return "";
    }
  }

  // This is a smart function to return either
  // the total inclusive results or, if we've exceeded
  // the computed total then return just the totalResults
  function computedInclusiveResultsShownTotal(){
    if(isBeforeLastPage()){
      return inclusiveResultsShownTotal();
    }
    else{
      return totalResults();
    }
  }

  // the total amount of records up-to-and-including current page
  function inclusiveResultsShownTotal(){
    return perPageSize() * nextPageNumber();
  }

  // the total amount of records up-to-excluding current page (add 1 after for range)
  function exclusiveResultsShownTotal(){
    return (perPageSize() * currentPageNumber()) + 1;
  }

  function totalResults(){
    return getTableData().totalElements;
  }

  function hasTableData(){
    return totalResults() > 0;
  }

  function isFirstPage(){
    return currentPageNumber() <= 0;
  }

  function isBeforeLastPage(){
    return totalResults() > inclusiveResultsShownTotal();
  }

  function perPageSize(){
    return getTableData().size;
  }

  function currentPageNumber(){
    return getTableData().number;
  }

  function nextPageNumber(){
    return currentPageNumber() + 1;
  }

  function prevPageNumber(){
    return currentPageNumber() - 1;
  }

  function getTableData(){
    return opts.paginationData;
  }

  // BUTTON TABS (DID I MENTION THIS WILL BE A COMPONENT?)
  function toggleShownTab(e) {
    e.preventDefault();
    let btnEl = $(e.target);
    let parentClass = "." + btnEl.data('parent');
    let targetClass = "." + btnEl.data('target');
    let parentEl = btnEl.closest(parentClass);
    let targetContainerEl = parentEl.find(targetClass);
    let isValid = validateChildren();
    if (isValid) {
      parentEl.find('.active').removeClass('active');
      targetContainerEl.addClass('active');
      btnEl.addClass('active');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/lookupTable/index.js